import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  ElementiStrutturaliL1SectionWrapper,
  InspectionInfoForm,
} from 'components';
import {
  CDAOptions,
  tipoElementoExtraImpalcatoOptions,
  tipologiaElementoExtraOptions,
} from 'constants/selectOptions';
import useTabellaRiepilogativa from 'hooks/inspections/useTabellaRiepilogativa';
import { INFO } from 'pages/Inspections/config/info';
import { calculateDifettositaComplessiva } from 'pages/Inspections/CreateInspection/utils/extractDefectivenessInfo';
import ElementiExtraForm from './ElementiExtraForm';
const ElementiExtraSection = ({ selectedIdx }) => {
  const { recalculateTable } = useTabellaRiepilogativa();
  const { watch, setValue, getValues } = useFormContext();

  const mensoleTamponiCampateImpalcatoTableElementiExtraTableWatch = watch(
    `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].elementiExtraTable`
  );

  const mensoleTamponiCampateImpalcatoTable = watch(
    `mensoleTamponiCampateImpalcatoTable`
  );
  //console.log(spallePileCollegamentiTable, 'spallePileCollegamentiTable');

  const mensoleTamponiCampateToCopy = mensoleTamponiCampateImpalcatoTable?.map(
    el => el.elementiExtraTable
  );

  const [selected, setSelected] = useState([]);
  const [open, setOpen] = useState(false);
  const [drawerMediaIndex, setDrawerMediaIndex] = useState();
  const [openSchedaDifetti, setOpenSchedaDifetti] = useState(false);
  const [schedaDifettiIndex, setSchedaDifettiIndex] = useState();

  const editRowsElementiExtra = item => {
    setValue('elementiExtraTableValue', [item]);
    setValue('tipoElementoExtraTableValue', item.tipoElementoExtra);
    setValue('tipologiaElementoExtraTableValue', item.tipologiaElementoExtra);
  };

  const handleSelectAllClickElementiExtra = event => {
    if (event.target.checked) {
      const selectedValue = getValues(
        `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].elementiExtraTable`
      );
      setSelected(selectedValue);
      setValue('elementiExtraTableValue', selectedValue);
    } else {
      setSelected([]);
      setValue('elementiExtraTableValue', []);
    }
  };

  useEffect(() => {
    setValue(
      'l1t2a4_tecnicoRilevatoreElementiExtra',
      getValues(
        `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].elementiExtraTable[${schedaDifettiIndex}].tecnicoRilevatore`
      ) ||
        getValues('rilevatoreRischioStrutturale') ||
        ''
    );
    setValue(
      'l1t2a4_dataIspezioneElementiExtra',
      getValues(
        `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].elementiExtraTable[${schedaDifettiIndex}].dataIspezione`
      ) ||
        getValues('dataIspezioneRischioStrutturale') ||
        null
    );
    setValue(
      'l1t2a4_elementoCriticoStrutturaElementiExtra',
      getValues(
        `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].elementiExtraTable[${schedaDifettiIndex}].elementoCriticoStruttura`
      ) || ''
    );
    setValue(
      'l1t2a4_elementoCriticoSismicaElementiExtra',
      getValues(
        `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].elementiExtraTable[${schedaDifettiIndex}].elementoCriticoSismica`
      ) || ''
    );
    setValue(
      'l1t2a4_condizioneCriticaStrutturaElementiExtra',
      getValues(
        `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].elementiExtraTable[${schedaDifettiIndex}].condizioneCriticaStruttura`
      ) || ''
    );
    setValue(
      'l1t2a4_condizioneCriticaSismicaElementiExtra',
      getValues(
        `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].elementiExtraTable[${schedaDifettiIndex}].condizioneCriticaSismica`
      ) || ''
    );
    setValue(
      'l1t2a4_noteGeneraliElementiExtra',
      getValues(
        `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].elementiExtraTable[${schedaDifettiIndex}].noteGenerali`
      ) || ''
    );
  }, [schedaDifettiIndex]);

  const handleSaveInspection = () => {
    const tecnicoRilevatore = getValues(
      'l1t2a4_tecnicoRilevatoreElementiExtra'
    );
    const dataIspezione = getValues('l1t2a4_dataIspezioneElementiExtra');
    const elementoCriticoStruttura = getValues(
      'l1t2a4_elementoCriticoStrutturaElementiExtra'
    );
    const elementoCriticoSismica = getValues(
      'l1t2a4_elementoCriticoSismicaElementiExtra'
    );
    const condizioneCriticaStruttura = getValues(
      'l1t2a4_condizioneCriticaStrutturaElementiExtra'
    );
    const condizioneCriticaSismica = getValues(
      'l1t2a4_condizioneCriticaSismicaElementiExtra'
    );
    const noteGenerali = getValues('l1t2a4_noteGeneraliElementiExtra');
    setValue(
      `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].elementiExtraTable[${schedaDifettiIndex}].tecnicoRilevatore`,
      tecnicoRilevatore
    );
    setValue(
      `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].elementiExtraTable[${schedaDifettiIndex}].dataIspezione`,
      dataIspezione
    );
    setValue(
      `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].elementiExtraTable[${schedaDifettiIndex}].elementoCriticoStruttura`,
      elementoCriticoStruttura
    );
    setValue(
      `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].elementiExtraTable[${schedaDifettiIndex}].elementoCriticoSismica`,
      elementoCriticoSismica
    );
    setValue(
      `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].elementiExtraTable[${schedaDifettiIndex}].condizioneCriticaStruttura`,
      condizioneCriticaStruttura
    );
    setValue(
      `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].elementiExtraTable[${schedaDifettiIndex}].condizioneCriticaSismica`,
      condizioneCriticaSismica
    );
    setValue(
      `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].elementiExtraTable[${schedaDifettiIndex}].noteGenerali`,
      noteGenerali
    );
    setValue('l1t2a5_trigger', Math.random() * 1000);
    setTimeout(() => {
      recalculateTable();
    }, 0);

    // Gestione calcolo difettosità complessiva nella tabella riepilogativa
    const tableWatch = getValues('riepilogoStrutturaTable');
    const difettositaStrutturaleEffettiva = watch(
      'arbitraryStructuralFoundationalDefectiveness'
    );
    const difettositaSismicaEffettiva = watch('arbitrarySeismicDefectiveness');
    const tabellaRiepilogativa = tableWatch.filter(
      row => row.codice !== 'Difettosità complessiva'
    );
    const { difettositaStrutturale, difettositaSismica } =
      calculateDifettositaComplessiva(tabellaRiepilogativa);
    const updatedTable = tableWatch.map(row => {
      if (row.codice === 'Difettosità complessiva') {
        return {
          ...row,
          difettositaStrutturale,
          difettositaSismica,
        };
      }
      return row;
    });
    setValue('riepilogoStrutturaTable', updatedTable);
    !difettositaStrutturaleEffettiva &&
      setValue(
        'arbitraryStructuralFoundationalDefectiveness',
        difettositaStrutturale
      );
    !difettositaSismicaEffettiva &&
      setValue('arbitrarySeismicDefectiveness', difettositaSismica);
  };

  const handleResetInspection = () => {
    setValue(`l1t2a4_tecnicoRilevatoreElementiExtra`, '');
    setValue(`l1t2a4_dataIspezioneElementiExtra`, null);
    setValue(`l1t2a4_elementoCriticoStrutturaElementiExtra`, '');
    setValue(`l1t2a4_elementoCriticoSismicaElementiExtra`, '');
    setValue(`l1t2a4_condizioneCriticaStrutturaElementiExtra`, '');
    setValue(`l1t2a4_condizioneCriticaSismicaElementiExtra`, '');
    setValue(`l1t2a4_noteGeneraliElementiExtra`, '');
  };

  const dataElementiExtraConfig = {
    columns: {
      codice: { label: 'Cod.' },
      tipoElementoExtra: {
        label: 'Tipo Elemento',
        format: tipoElementoExtraImpalcatoOptions,
      },
      tipologiaElementoExtra: {
        label: 'Tipologia',
        format: tipologiaElementoExtraOptions,
      },
      completamentoSchedaDifetti: { label: 'Completamento Scheda' },
      indiceCondizione: { label: 'Indice di condizione' },
      CDAstrutturale: { label: 'Difettosità Str.', format: CDAOptions },
      CDAsismica: { label: 'Difettosità Sis.', format: CDAOptions },
      nrtotali: { label: 'NR' },
      g5totali: { label: 'G=5' },
      pstotali: { label: 'PS' },
    },
  };

  const copyTableConfig = {
    columns: {
      codice: { label: 'Codice' },
      tipoElementoExtra: {
        label: 'Tipo Elemento',
        format: tipoElementoExtraImpalcatoOptions,
      },
      tipologiaElementoExtra: {
        label: 'Tipologia',
        format: tipologiaElementoExtraOptions,
      },
    },
  };

  const mensoleTamponiCampateImpalcatoSelezione = watch(
    'mensoleTamponiCampateImpalcatoSelezione'
  );

  useEffect(() => {
    if (mensoleTamponiCampateImpalcatoSelezione) {
      setSchedaDifettiIndex(undefined);
      setOpenSchedaDifetti(false);
    }
  }, [mensoleTamponiCampateImpalcatoSelezione]);

  useEffect(() => {
    if (schedaDifettiIndex !== undefined) {
      setOpenSchedaDifetti(true);
    }
  }, [schedaDifettiIndex]);

  return (
    <>
      <ElementiStrutturaliL1SectionWrapper
        selectedIdx={selectedIdx}
        elementTitle={'elementi aggiuntivi'}
        infoDrawer={true}
        drawerTitle={INFO.impalcatoElementiExtra.drawerTitle}
        drawerText={INFO.impalcatoElementiExtra.drawerText}
        singleElementTitle={'elemento aggiuntivo'}
        tableWatch={mensoleTamponiCampateImpalcatoTableElementiExtraTableWatch}
        tableWatchName={`mensoleTamponiCampateImpalcatoTable[${selectedIdx}].elementiExtraTable`}
        elementForm={
          <ElementiExtraForm
            elementiExtraFields={
              mensoleTamponiCampateImpalcatoTableElementiExtraTableWatch || []
            }
            selected={selected}
            setSelected={setSelected}
            elementiExtraTable={`mensoleTamponiCampateImpalcatoTable[${selectedIdx}].elementiExtraTable`}
            selectedIdx={selectedIdx}
          />
        }
        inspectionInfoForm={
          <InspectionInfoForm
            onSubmit={handleSaveInspection}
            onReset={handleResetInspection}
            tecnicoRilevatoreName={'l1t2a4_tecnicoRilevatoreElementiExtra'}
            dateName={'l1t2a4_dataIspezioneElementiExtra'}
            elementoCriticoStrutturaName={
              'l1t2a4_elementoCriticoStrutturaElementiExtra'
            }
            elementoCriticoSismicaName={
              'l1t2a4_elementoCriticoSismicaElementiExtra'
            }
            condizioneCriticaStrutturaName={
              'l1t2a4_condizioneCriticaStrutturaElementiExtra'
            }
            condizioneCriticaSismicaName={
              'l1t2a4_condizioneCriticaSismicaElementiExtra'
            }
            noteGeneraliName={'l1t2a4_noteGeneraliElementiExtra'}
          />
        }
        tableConfig={dataElementiExtraConfig}
        editRows={editRowsElementiExtra}
        selected={selected}
        setSelected={setSelected}
        handleSelectAllClick={handleSelectAllClickElementiExtra}
        drawerMediaIndex={drawerMediaIndex}
        setDrawerMediaIndex={setDrawerMediaIndex}
        schedaDifettiIndex={schedaDifettiIndex}
        setSchedaDifettiIndex={setSchedaDifettiIndex}
        open={open}
        setOpen={setOpen}
        openSchedaDifetti={openSchedaDifetti}
        setOpenSchedaDifetti={setOpenSchedaDifetti}
        copyTableConfig={copyTableConfig}
        copyType={['tipoElementoExtra', 'tipologiaElementoExtra']}
        tableForCopy={mensoleTamponiCampateToCopy}
        elementTypeField="tipoElementoExtra"
        elementTypeOptions={tipoElementoExtraImpalcatoOptions}
      />
    </>
  );
};
ElementiExtraSection.propTypes = {
  selectedIdx: PropTypes.number,
};
export default ElementiExtraSection;
